<template>
  <div class="portal-progress-div">
    <div class="progress-div" v-for="(item, index) in progressItems" :key="`progress-${index}`">
      <div class="portal_progress-box">
        <!-- Program Info Section -->
        <div class="program-div">
          <div class="program-info-div">
            <div class="program-image-div">
              <img 
                :src="getProductImage(item.product_id)" 
                :srcset="getProductSrcSet(item.product_id)"
                alt="defaultProductName" 
                class="program-image"
                loading="lazy"
              >
            </div>
            <div>
              <div class="program-name-text">{{ getFullProductName(item.product_id) }}</div>
              <a href="#" class="link-52" v-if="getStepIndex(item.status) >= getStepIndex('prescription_received')" @click.prevent="executeFunction('showPrescription', item)">Click Here to Access Instructions</a>
              <br/>
              
            </div>
          </div>
          <div class="progress_statusdiv">
            <img 
              :src="getMainStatusIcon(item.status)" 
              loading="lazy" 
              alt="" 
              class="image-476"
            >
            <div class="text-block-849">{{ getMainStatusText(item.status) }}</div>
          </div>
        </div>

        <!-- Progress Steps Section -->
        <div class="progress-drop-div">
          <div 
            class="progress-bullet" 
            v-for="step in visibleSteps(item.status)" 
            :key="step.status"
          >
            <img 
              :src="getStepIcon(step.status, item.status)" 
              loading="lazy" 
              alt="" 
              class="image-442"
            >
            <div class="progress-bullet-text-div">
              <div class="text-block-930">{{ step.title }}</div>
              <div class="text-block-931" v-html="step.description"></div>
              <template v-if="step.status === item.status || 
                        (step.status === 'pending_approval' && item.status === 'pending_approval') ||
                        (step.status === 'prescription_received' && item.status === 'prescription_received')">
                <component 
                  v-if="!step.isFunction"
                  :is="step.linkType" 
                  :to="step.link" 
                  :href="step.link" 
                  class="link-58"
                  target="_blank"
                >
                  {{ step.action }} <span class="text-span-234" v-if="step.action">-></span>
                </component>
                <a 
                  v-else
                  href="#" 
                  class="link-58"
                  @click.prevent="executeFunction(step.functionName, item)"
                >
                  {{ step.action }} <span class="text-span-234">-></span>
                </a>
              </template>
            </div>
          </div>
          <div class="div-block-1848"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';
import iconUrgent from '@/assets/images/icon_Urgent.svg';
import iconCheckGreen from '@/assets/images/icon_Check-green.svg';
import processingIcon from '@/assets/images/icon_Urgent-yellow.svg';
import iconOpen from '@/assets/images/icon_open_1.svg';
import {
  getProductById,
} from '@/utils/productData'

export default {
  name: 'ProgressTracker',

  props: {
    progressItems: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      showModel: false,
      baseUrl: `${process.env.VUE_APP_API_ENDPOINT}`,
      steps: [
        {
          status: 'payment',
          title: 'Successful Payment',
          description: 'Complete payment for your medication.',
          action: 'Make Payment',
          link: '/payment',
          linkType: 'router-link',
          isFunction: false
        },
        {
          status: 'pending_approval',
          title: 'Medical Questionnaire',
          description: 'This will be reviewed by our doctor in order to prescribe your medication.',
          action: 'Complete Medical Form',
          link: '/case-questions',
          linkType: 'router-link',
          isFunction: false
        },
        {
          status: 'waiting_prescription',
          title: 'Final Doctor Approval',
          description: 'Your doctor is reviewing your records. Please allow 24-48 hours.',
          action: 'Re-Upload Images ❗️Only When Requested❗️',
          link: '#',
          linkType: 'a',
          isFunction: true,
          functionName: 'showImageUpload'
        },
        {
          status: 'prescription_received',
          title: 'Prescription Approved',
          description: 'Your prescription has been approved by the doctor.',
          action: 'View Prescription',
          link: '#',
          linkType: 'a',
          isFunction: true,
          functionName: 'showPrescription'
        },
        {
          status: 'order_placed',
          title: 'Pharmacy is Fulfilling the order',
          description: 'This usually takes 24 business hours to complete. Except on Sundays and recognized holidays.',
          action: '',
          link: '#',
          linkType: 'a',
          isFunction: false
        },
        {
          status: 'order_shipped',
          title: 'Medication Has Shipped',
          description: 'Packages are sent 2 Day Express. Except on Sundays and recognized holidays.',
          action: 'Track Shipment',
          link: '#',
          linkType: 'a',
          isFunction: false
        },
        {
          status: 'order_delivered',
          title: 'Medication Delivered',
          description: 'This usually takes 24 hours to complete.',
          action: 'View Delivery Details',
          link: '#',
          linkType: 'a',
          isFunction: false
        }
      ]
    }
  },

  methods: {
    
    executeFunction(functionName, item) {
      if (functionName === 'downloadInvoice') {
        let program = this.getFullProductName(item.product_id);
        this.downloadInvoice(item.payment_intent_id, program);
      } else if (functionName === 'showPrescription') {
        console.log("this is running")
        this.$emit('showModel', item.prescription_data)
      } else if (functionName === 'sendDocMessage') {
        this.$emit('showModelMessage', item.id)
      } else if (functionName === 'showImageUpload') {
        this.$emit('showImageUpload', item.id)
      }
    },

    async downloadInvoice(paymentIntentId, program) {
      try {
        await this.$axios.get(`${this.baseUrl}/invoice?id=${paymentIntentId}&program=${program}`).then(response => {
          if (response.data.status == 'error') {
            console.log("error");
          } else {
            const options = {
              margin: 0,
              filename: `${paymentIntentId}.pdf`,
              image: {
                type: 'jpeg',
                quality: 1
              },
              html2canvas: {
                dpi: 300,  
                scale: 4,
                letterRendering: true,
                useCORS: true,
                windowWidth: 794,
                windowHeight: 1123,
                scrollX: 0,
                scrollY: 0,
                onrendered: function(canvas) {
                  canvas.style.imageRendering = 'pixelated';
                  canvas.style.imageRendering = '-webkit-optimize-contrast';
                }
              },
              jsPDF: {
                unit: 'mm',
                format: [210, 297],
                orientation: 'portrait',
                compress: true,
                precision: 16,
                userUnit: 1.0,
                textColor: "#000000",
                fillColor: "#000000"
              }
            };
            html2pdf().set(options).from(response.data).save();
            console.log("generated");
          }
        });
      } catch (error) {
        console.error('Error downloading invoice:', error);
      }
    },

    getFullProductName(id) {
      let product = getProductById(id);
      return product[0].name;
    },

    getProductSrcSet(id) {
      let product = getProductById(id);
      let img = `https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${product[0].image_pre_text}/1.webp`;
      return `${img} 500w, ${img} 800w, ${img} 1080w`
    },

    getProductImage(id) {
      let product = getProductById(id);
      return `https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${product[0].image_pre_text}/1.webp`;
    },

    getMainStatusIcon(status) {
      const urgentStatuses = ['pending_approval'];
      const processingStatus = ['payment_failed', 'appointment_required', 'waiting_prescription', 'prescription_received', 'order_placed', 'order_shipped'];
      if (urgentStatuses.includes(status)) {
        return iconUrgent;
      } else if (processingStatus.includes(status)) {
        return processingIcon
      } else if (status === 'order_delivered') {
        return iconCheckGreen
      } else {
        return processingIcon
      }
    },

    getMainStatusText(status) {
      const urgentStatuses = ['pending_approval'];
      const processingStatus = ['payment_failed', 'appointment_required', 'waiting_prescription', 'prescription_received', 'order_placed', 'order_shipped'];
      if (urgentStatuses.includes(status)) {
        return 'Needs Review';
      } else if (processingStatus.includes(status)) {
        return "Processing"
      } else if (status === 'order_delivered') {
        return 'Complete'
      } else {
        return "Processing"
      }
    },

    getStepIndex(status) {
      return this.steps.findIndex(step => step.status === status);
    },

    getStepIcon(stepStatus, currentStatus) {
      const currentIndex = this.getStepIndex(currentStatus);
      const stepIndex = this.getStepIndex(stepStatus);

      // If step is already completed
      if (stepIndex < currentIndex) {
        return iconCheckGreen;
      }
      
      // If this is the current step
      if (stepIndex === currentIndex) {
        if (currentStatus === 'pending_approval') {
          return iconUrgent; // Red icon for pending approval
        }
        if (['waiting_prescription', 'prescription_received', 'order_placed'].includes(currentStatus)) {
          return processingIcon; // Yellow for processing states
        }
        return processingIcon; // Yellow icon for current step
      }
      
      // Future steps
      return iconOpen; // Open icon for unreached steps
    },

    visibleSteps(currentStatus) {
      const item = this.progressItems.find(i => i.status === currentStatus);
      if (!item) return [];

      // Create a copy of base steps with dynamic values
      let dynamicSteps = this.steps.map(step => {
        const stepCopy = { ...step };

        // Set dynamic assessment link
        if (step.status === 'pending_approval') {
          stepCopy.link = `/case-questions/${item.id}`;
        }
        
        if (step.status === 'waiting_prescription') {
          stepCopy.link = `/invoice/${item.payment_intent_id}`;
        }

        // Set dynamic tracking info
        if (step.status === 'order_shipped' && item.tracking_number) {
          stepCopy.description = `Carrier: <strong>${item.logistics_provider}</strong><br/>Tracking Number: <strong>${item.tracking_number}</strong>`;
          if(item.logistics_provider==='FedEx'){
            stepCopy.link = `https://www.fedex.com/fedextrack/?trknbr=${item.tracking_number}`;
          }else{
            stepCopy.link = `https://www.ups.com/track?tracknum=${item.tracking_number}&loc=en_US`;
          }
        }

        if (step.status === 'order_delivered') {
          stepCopy.description = `Your medication was successfully delivered to your home.`;
        }

        return stepCopy;
      });

      // Remove payment_failed step for all statuses
      dynamicSteps = dynamicSteps.filter(step => step.status !== 'payment_failed');
      
      // Always return all steps
      return dynamicSteps;
    }
  }
};
</script>

<style scoped>

</style>